import { render, staticRenderFns } from "./tab-header.vue?vue&type=template&id=6b0e7117&scoped=true&"
import script from "./tab-header.vue?vue&type=script&lang=js&"
export * from "./tab-header.vue?vue&type=script&lang=js&"
import style0 from "./tab-header.vue?vue&type=style&index=0&id=6b0e7117&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@5.2.7_vue-template-compiler@2.6.11_webpack@5.75.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e7117",
  null
  
)

export default component.exports